import { Injectable } from '@angular/core';
import { BroadcastChannel } from 'broadcast-channel';

import { ChangeLogService } from './change-log.service';
import { ChangeLogEvent } from '@app/core/db/change-log';
import { env } from '../../../environments/env';

@Injectable({
  providedIn: 'root',
})
export class ChangeTraceService {
  constructor(private changeLogService: ChangeLogService) {}

  async register() {
    if (env.get().production) {
      return;
    }

    const syncChannel = new BroadcastChannel('dwo-sync');
    syncChannel.onmessage = (message) => {
      if (message.type === 'processed') {
        this.print(message.item);
      }
    };

    this.changeLogService.subscribeAll(this.print.bind(this));
  }

  private print(event: ChangeLogEvent) {}
}
